import React from "react";

// Icone "a documento colorato" per Excel/PDF: non i loghi ufficiali
// Microsoft/Adobe (marchi registrati, non riproducibili), ma la stessa
// convenzione visiva molto diffusa — foglio con angolo piegato, colore e
// sigla riconoscibili a colpo d'occhio anche in una fila di file diversi.
export function IconaExcel({ size = 22 }) {
  return (
    <svg width={size} height={size * (42 / 36)} viewBox="0 0 36 42" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 2h18l10 10v26a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#107C41" />
      <path d="M22 2l10 10H24a2 2 0 0 1-2-2V2z" fill="#0B5A30" />
      <text x="18" y="31" textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff" fontFamily="Arial, Helvetica, sans-serif">XLS</text>
    </svg>
  );
}

export function IconaPdf({ size = 22 }) {
  return (
    <svg width={size} height={size * (42 / 36)} viewBox="0 0 36 42" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 2h18l10 10v26a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" fill="#DC3545" />
      <path d="M22 2l10 10H24a2 2 0 0 1-2-2V2z" fill="#A3242F" />
      <text x="18" y="31" textAnchor="middle" fontSize="10" fontWeight="700" fill="#fff" fontFamily="Arial, Helvetica, sans-serif">PDF</text>
    </svg>
  );
}
